import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

const ToolRender = ({
  tool,
  scrollPosition,
  liveElementId,
  handleActionEnd,
  handleActionStart,
  interpolatingStyle,
}) => {
  const { elementId, container: ToolContainer } = tool;

  const onActionStart = useCallback(() => {
    handleActionStart(tool, liveElementId);
  }, [handleActionStart, tool, liveElementId]);

  const appearanceStyle = useMemo(
    () => ({
      opacity: interpolatingStyle.opacity,
      transform: `scale(${interpolatingStyle.scale})`,
    }),
    [interpolatingStyle.scale, interpolatingStyle.opacity]
  );

  return (
    <ToolContainer
      appearanceStyle={appearanceStyle}
      elementId={elementId}
      scrollPosition={scrollPosition}
      onActionStart={onActionStart}
      onActionEnd={handleActionEnd}
    />
  );
};

ToolRender.propTypes = {
  tool: PropTypes.shape({
    id: PropTypes.string.isRequired,
    elementId: PropTypes.string.isRequired,
    container: PropTypes.elementType.isRequired,
  }).isRequired,
  scrollPosition: PropTypes.number.isRequired,
  liveElementId: PropTypes.string.isRequired,
  handleActionEnd: PropTypes.func.isRequired,
  handleActionStart: PropTypes.func.isRequired,
  interpolatingStyle: PropTypes.shape({
    opacity: PropTypes.number.isRequired,
    scale: PropTypes.number.isRequired,
  }).isRequired,
};

export default ToolRender;
